import React, { createContext, useContext } from "react";

const AppConfigurationContext = createContext();

const useAppConfig = () => {
  return useContext(AppConfigurationContext);
};

const AppConfigurationProvider = ({ appConfig, children }) => {
  return (
    <AppConfigurationContext.Provider value={{ appConfig }}>
      {children}
    </AppConfigurationContext.Provider>
  );
};

export { AppConfigurationProvider, useAppConfig };
